export default __webpack_public_path__ + "static/media/table-sub-components.8ba27de0.svg";